import * as React from 'react';
import Draggable, { DraggableEventHandler } from 'react-draggable';
import { ResizeCallback, ResizableDirection, NumberSize, Resizable } from 're-resizable'
import { Rnd } from 'react-rnd'
import './MeetingModule.css';

const style = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "solid 1px #ddd",
    background: "#f0f0f0"
};

class MeetingModule extends React.Component {
    state = {
        onLoadPosition: undefined
    }
    componentDidMount() {
        const onLoadPosition = {
            x: this.props.position.x,
            y: this.props.position.y
        }
        this.setState({ onLoadPosition: onLoadPosition });
    }
    onDragStop = (e, data) => {
        this.setState({ onLoadPosition: undefined });
        const { module } = this.props;
        this.props.onChange("position", module.digitalMeetingItemId, { x: data.x, y: data.y, zIndex: this.props.position.zIndex });
    }
    onResizeStop = (e, direction, ref, delta) => {
        const { module } = this.props;
        let w = Math.round(window.innerWidth * (this.props.size.width / 100));
        let h = Math.round(window.innerHeight * (this.props.size.height / 100));

        this.props.onChange("size", module.digitalMeetingItemId, {
            width: Math.round(((delta.width + w) / window.innerWidth) * 100),
            height: Math.round(((delta.height + h) / window.innerHeight) * 100)
        });
    }
    render() {
        const { name, onSelect, position, index, size, settings, onChange, isDisabled = false, module } = this.props;

        const disableDrag = isDisabled ? {
            top: false,
            right: false,
            bottom: false,
            left: false,
            topRight: false,
            bottomRight: false,
            bottomLeft: false,
            topLeft: false
        } : {
                top: true,
                right: true,
                bottom: true,
                left: true,
                topRight: true,
                bottomRight: true,
                bottomLeft: true,
                topLeft: true
            };

        return (
            <div
                className="GenericModule"
                style={{ zIndex: position.zIndex, position: 'absolute' }}
            /* onClick={() => onSelect(id)} */
            >
                <Rnd
                    position={this.state.onLoadPosition}
                    onStop={this.onDragStop}
                    dragGrid={[500, 500]}
                    style={style}
                    size={{ width: size.width + 'vw', height: size.height + 'vh' }}
                    onResizeStop={this.onResizeStop}
                >
                    {name}
                </Rnd>

            </div>
        )
    }
}
export default MeetingModule;